import { render, staticRenderFns } from "./wenzhengRanking.vue?vue&type=template&id=2d658af6&scoped=true&"
import script from "./wenzhengRanking.vue?vue&type=script&lang=ts&"
export * from "./wenzhengRanking.vue?vue&type=script&lang=ts&"
import style0 from "./wenzhengRanking.vue?vue&type=style&index=0&id=2d658af6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d658af6",
  null
  
)

export default component.exports